import { Record } from 'immutable';
export default Record({
  active: null,
  enrolled: null
});